function broadcast(componentName, key, value) {
  this.$children.forEach((child) => {
    var name = child.$options.componentName
    if (name === componentName) {
      if (child.$attrs.prop == key) {
        child.setValue(value)
      }
    } else {
      broadcast.apply(child, [componentName, key].concat([value]))
    }
  })
}
import mixinListPage from '@/utils/mixinListPage'
import mixSubmit from '@/utils/mixSubmit'

const WorkYmFromTo = {
  render() {
    return (
      <vab-col>
        <el-row>
          <el-col span={24}>
            <el-form-item label="作業年月" class="is-required">
              <el-row type="flex">
                <el-col class="width_box_140">
                  <vab-date-picker
                    type="month"
                    placeholder="開始月"
                    value-format="yyyyMM"
                    format="yyyy/MM"
                    prop="workYm"
                    class="width_140"
                    label-error="作業年月"
                    clearable={false}
                    editable={false}
                    validate="required"
                    end-date-prop="workYmTo"
                    // on={{
                    //   change: () => {
                    //     this.$emit('clearTime', 'planWorkStartDate')
                    //   },
                    // }}
                  />
                </el-col>
                <el-col span={2} class="text_center">
                  ～
                </el-col>
                <el-col class="width_box_140">
                  <vab-date-picker
                    type="month"
                    label-show={false}
                    value-format="yyyyMM"
                    format="yyyy/MM"
                    prop="workYmTo"
                    class="width_140"
                    placeholder="終了月"
                    label-error="作業年月"
                    clearable={false}
                    editable={false}
                    validate="required"
                    start-date-prop="workYm"
                    // on={{
                    //   change: () => {
                    //     this.$emit('clearTime', 'planWorkEndDate')
                    //   },
                    // }}
                  />
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
        </el-row>
      </vab-col>
    )
  },
}
export default {
  mixins: [mixinListPage, mixSubmit],
  data() {
    return {
      lenList: 0,
    }
  },
  components: {
    WorkYmFromTo,
  },
  watch: {
    $route: {
      handler(router) {
        if (router.name == this.$options.name) {
          this.reloadData()
        }
      },
      immediate: true,
    },
  },
  computed: {
    defaultValue() {
      return (val) => {
        if (val) {
          return new Date(this.$dayjs(val).format('YYYY/MM'))
        }
      }
    },
  },
  mounted() {},
  created() {},
  methods: {
    // clearTime(prop) {
    //   this.queryForm[prop] = null
    // },
    cancelSet() {
      if (this.$route?.query?.top == 'top') {
        // this.$baseEventBus.$emit('reload-router-view')
      }
    },
    getComponent(componentName, key, value) {
      this.$nextTick(() => {
        let ths = this.$refs['queryForm']
        broadcast.call(ths, componentName, key, value)
      })
    },
    reloadData() {
      let params = this.$route?.query
      if (
        !this.$baseLodash.isEmpty(params) &&
        this.$route?.query?.top == 'top' &&
        this.autoReload
      ) {
        let form = this.queryForm
        Object.keys(form).filter((key) => {
          if (key.endsWith('List') && !Array.isArray(params[key])) {
            if (!this.$baseLodash.isEmpty(params[key])) {
              this.$set(this.queryForm, key, Array.of(params[key]) ?? null)
              this.getComponent('VabSelect', key, [params[key]])
            }
          } else {
            if (params[key]) {
              this.$set(this.queryForm, key, params[key] ?? null)
              this.getComponent('VabSelect', key, params[key])
            }
            if (!this.$baseLodash.isEmpty(params.workYm)) {
              let year = this.$dayjs(params.workYm).format('YYYY')
              let month = this.$dayjs(params.workYm).format('MM')
              this.$set(this.queryForm, 'workY', year ?? null)
              this.$set(this.queryForm, 'workM', month ?? null)
            }
          }
        })
        if (params?.top) {
          this.$nextTick(() => {
            this.fetchData()
          })
        }
      }
    },
    setQueryParamsLoad(pageData) {
      return new Promise((resolve) => {
        setTimeout(() => {
          this.queryForm = this.setQueryParams(pageData)
          resolve(pageData)
        }, 0)
      })
    },
    setQueryParams(pageData) {
      if (this.$baseLodash.isEmpty(pageData)) {
        return {}
      }
      pageData = this.$baseLodash.clone(pageData)
      Object.keys(pageData).filter((item) => {
        if (item.endsWith('List') && !Array.isArray(pageData[item])) {
          if (!this.$baseLodash.isEmpty(pageData[item])) {
            pageData[item] = Array.of(pageData[item])
          }
        }
        //作業実績
        if (this.queryForm['planWorkStartDateFrom'] && pageData.workYm) {
          let from =
            pageData.workYm.toString() + this.queryForm['planWorkStartDateFrom']
          pageData['planWorkStartDateFrom'] = this.$dayjs(from).format(
            this.$const.dateFormatYYYYMMDD
          )
        }
        if (this.queryForm['planWorkStartDateTo'] && pageData.workYm) {
          let to =
            pageData.workYm.toString() + this.queryForm['planWorkStartDateTo']
          pageData['planWorkStartDateTo'] = this.$dayjs(to).format(
            this.$const.dateFormatYYYYMMDD
          )
        }
        // 作業予定
        if (this.queryForm['planWorkStartDate'] && pageData.workYm) {
          let from =
            pageData.workYm.toString() + this.queryForm['planWorkStartDate']
          pageData['planWorkStartDate'] = this.$dayjs(from).format(
            this.$const.dateFormatYYYYMMDD
          )
        }
        if (this.queryForm['planWorkEndDate'] && pageData.workYm) {
          let to =
            pageData.workYm.toString() + this.queryForm['planWorkEndDate']
          pageData['planWorkEndDate'] = this.$dayjs(to).format(
            this.$const.dateFormatYYYYMMDD
          )
        }
        if (
          !this.$baseLodash.isEmpty(pageData.workYm) &&
          this.$options.name != 'PWR01G01'
        ) {
          let year = this.$dayjs(pageData.workYm).format('YYYY')
          let month = this.$dayjs(pageData.workYm).format('MM')
          pageData['workY'] = year
          pageData['workM'] = month
        }
      })
      return pageData
    },
    // 速報版報告書状況
    getPreReportStatusList() {
      setTimeout(() => {
        let options = this.$refs.preReportStatus.options
        let extentList = [
          this.$divisions.reportStatusEnum.enum_10.value,
          this.$divisions.reportStatusEnum.enum_11.value,
          this.$divisions.reportStatusEnum.enum_15.value,
          this.$divisions.reportStatusEnum.enum_16.value,
          this.$divisions.reportStatusEnum.enum_20.value,
          this.$divisions.reportStatusEnum.enum_21.value,
          this.$divisions.reportStatusEnum.enum_22.value,
        ]
        let list = options.filter((item) => !extentList.includes(item.value))
        console.log(list)
        this.$refs.preReportStatus.options = list
      }, 0)
    },
    // 正式版報告書状況
    getOfficalReportStatusList() {
      setTimeout(() => {
        let options = this.$refs.officalReportStatus.options
        let extentList = [
          this.$divisions.reportStatusEnum.enum_20.value,
          this.$divisions.reportStatusEnum.enum_21.value,
          this.$divisions.reportStatusEnum.enum_22.value,
        ]
        let list = options.filter((item) => !extentList.includes(item.value))
        this.$refs.officalReportStatus.options = list
      }, 0)
    },
    // 報告書提出状況
    getDocSubmitStatusList() {
      setTimeout(() => {
        let options = this.$refs.docSubmitStatusRef.options
        let extentList = [
          this.$divisions.docSubmitStatusEnum.enum_6.value,
          this.$divisions.docSubmitStatusEnum.enum_7.value,
          this.$divisions.docSubmitStatusEnum.enum_8.value,
        ]
        let list = options.filter((item) => !extentList.includes(item.value))
        this.$refs.docSubmitStatusRef.options = list
      }, 0)
    },
    // セグメント
    getDemandTypeList() {
      setTimeout(() => {
        let options = this.$refs.demandTypeRef.options
        let extentList = [
          this.$divisions.demandTypeEnum.enum_x.value,
          this.$divisions.demandTypeEnum.enum_7.value,
          this.$divisions.demandTypeEnum.enum_5.value,
          this.$divisions.demandTypeEnum.enum_4.value,
        ]
        let list = options.filter((item) => !extentList.includes(item.value))
        this.$refs.demandTypeRef.options = list
      }, 0)
    },
    // 作業予定日時
    getWorkDateTime(date, s, e) {
      if (!date) return
      let day = this.$dayjs(date).format('DD')
      let ym = this.$dayjs(date).format('YYYY/MM/DD')
      let weeks = [
        {
          name: '日',
          val: 0,
        },
        {
          name: '月',
          val: 1,
        },
        {
          name: '火',
          val: 2,
        },
        {
          name: '水',
          val: 3,
        },
        {
          name: '木',
          val: 4,
        },
        {
          name: '金',
          val: 5,
        },
        {
          name: '土',
          val: 6,
        },
      ]
      let week = this.$dayjs(ym).day()
      let weekItem = this.$baseLodash.find(weeks, (item) => week == item.val)
      if (this.$baseLodash.isUndefined(weekItem)) return
      return ` ${day} 日 (${weekItem.name}) ${s ? s + ' ~ ' : ''}  ${
        e ? e : ''
      }`
    },
    rowClassName(row, rowIndex, key, list) {
      if (list.length == 0) return
      let ids = list.map((item) => item[key])
      if (ids.includes(row[key])) {
        return 'rowClassName'
      }
    },
    // 開始予定日チェック
    blurTimeFrom() {
      let from = this.queryForm.planWorkStartDate
      let to = this.queryForm.planWorkEndDate
      if (to && Number(from) > Number(to)) {
        this.queryForm.planWorkStartDate = JSON.parse(JSON.stringify(to))
      }
    },
    // 予定終了日チェック
    blurTimeTo() {
      let day = this.$dayjs(`${this.queryForm.workYm}/01`).daysInMonth()
      let from = this.queryForm.planWorkStartDate
      let to = this.queryForm.planWorkEndDate
      if (Number(to) > Number(day)) {
        this.queryForm.planWorkEndDate = JSON.parse(JSON.stringify(day))
      } else {
        if (to && Number(to) < Number(from)) {
          this.queryForm.planWorkEndDate = JSON.parse(JSON.stringify(from))
        }
      }
    },
    // 入力制限
    setStartDate() {
      if (
        !this.queryForm.planWorkStartDate ||
        +this.queryForm.planWorkStartDate >
          (this.$dayjs(`${this.queryForm.workYm}/01`).daysInMonth() || 31)
      ) {
        this.queryForm.planWorkStartDate = ''
      }
    },
    // 入力制限
    setEndDate() {
      if (
        !this.queryForm.planWorkEndDate ||
        +this.queryForm.planWorkEndDate >
          (this.$dayjs(`${this.queryForm.workYm}/01`).daysInMonth() || 31)
      ) {
        this.queryForm.planWorkEndDate = ''
      }
    },
    // 作業年月チェックです
    workYmVerify() {
      if (
        this.$baseLodash.isEmpty(this.queryForm.workYm) ||
        this.$baseLodash.isEmpty(this.queryForm.workYmTo)
      ) {
        this.$refs['queryForm'].queryData()
        this.msgError(
          this.format(
            this.$t(`validateMessage.${this.$messageCode.E00000046.name}`),
            '作業年月'
          )
        )
        return true
      }
    },
  },
}
